module.exports = __webpack_public_path__ + "static/resources-disable-backup-confirm-5402d9817939fcb8eb8189b4573cb435.png";